import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomeView from './modules/HomeView';
import Account from './modules/Account';
import MyTickets from './modules/MyTickets';
import OrganizerDashboard from './modules/OrganizerDashboard';
import OrganizerBusinessDetails from './modules/OrganizerBusinessDetails';
import OrganizerEventsView from './modules/OrganizerEventsView';
import OrganizerCreateEditEvent from './modules/OrganizerCreateEditEvent';
import EventDetail from './modules/EventDetail';
import OrganizerPaymentGateways from "./modules/OrganizerPaymentGateways";

import DashboardLayout from './layouts/DashboardLayout';
import PublicLayout from './layouts/PublicLayout';

import ProtectedRoute from './components/ProtectedRoute';

import AuthModal from './components/AuthModal';
import OrderConfirmation from "./modules/OrderConfirmation";
import OrganizerSales from './modules/OrganizerSales';
import OrganizerOrdersReview from './modules/OrganizerOrdersReview';
import OrganizerSettlements from './modules/OrganizerSettlements';
import OrganizerAccessControl from './modules/OrganizerAccessControl';

function App() {
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const [authModalView, setAuthModalView] = useState<'login' | 'register'>('login');

    const openLogin = () => { setAuthModalView('login'); setIsAuthModalOpen(true); };
    const openRegister = () => { setAuthModalView('register'); setIsAuthModalOpen(true); };

    return (
        <BrowserRouter>
            <Routes>
                {/* === GRUPO 1: RUTAS PÚBLICAS === */}
                <Route element={<PublicLayout onLoginClick={openLogin} onRegisterClick={openRegister} />}>
                    <Route path="/" element={<HomeView openRegister={openRegister} />} />

                    <Route path="/events/:id" element={<EventDetail />} />
                    <Route path="/payment" element={<OrderConfirmation />} />

                    <Route path="*" element={<div className="text-center py-20">Página no encontrada</div>} />
                </Route>

                {/* === GRUPO 2: RUTAS PRIVADAS === */}
                <Route element={<ProtectedRoute />}>
                    <Route element={<DashboardLayout onLoginClick={openLogin} onRegisterClick={openRegister} />}>

                        <Route path="/account" element={<Account />} />
                        <Route path="/tickets" element={<MyTickets />} />

                        <Route element={<ProtectedRoute allowedRoles={['user-organizer']} />}>
                            <Route path="/organizer/business-details" element={<OrganizerBusinessDetails />} />
                            <Route path="/organizer/dashboard" element={<OrganizerDashboard />} />
                            <Route path="/organizer/events" element={<OrganizerEventsView />} />
                            <Route path="/organizer/events/edit/:id" element={<OrganizerCreateEditEvent />} />
                            <Route path="/organizer/events/create" element={<OrganizerCreateEditEvent />} />
                            <Route path="/organizer/payment-gateways" element={<OrganizerPaymentGateways />} />
                            <Route path="/organizer/stats/sales" element={<OrganizerSales />} />
                            <Route path="/organizer/orders/review" element={<OrganizerOrdersReview />} />
                            <Route path="/organizer/settlements" element={<OrganizerSettlements />} />
                            <Route path="/organizer/access" element={<OrganizerAccessControl />} />
                            <Route path="/organizer/access/:eventId" element={<OrganizerAccessControl />} />
                        </Route>

                    </Route>
                </Route>

            </Routes>

            <AuthModal
                isOpen={isAuthModalOpen}
                onClose={() => setIsAuthModalOpen(false)}
                initialView={authModalView}
            />
        </BrowserRouter>
    );
}

export default App;